import React from 'react';
import { RendererCssClassName } from '../../consts';
import { useSelectAllTrap } from '../utils/use-select-all-trap';

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Doc(props) {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  return /*#__PURE__*/React.createElement("div", {
    className: RendererCssClassName.DOCUMENT
  }, props.children);
}

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function DocWithSelectAllTrap(props) {
  return /*#__PURE__*/React.createElement("div", {
    ref: useSelectAllTrap()
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: RendererCssClassName.DOCUMENT
  }, props.children);
}